import { Link } from "react-router-dom";
import { ArrowRight, Building2, Home as HomeIcon } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import Breadcrumbs from "../components/Breadcrumbs";
import CTASection from "../components/CTASection";

export default function FrontLoadHub() {
  return (
    <>
      <SEO
        title="Front-Load Dumpster Service"
        description="Recurring front-load waste service across Yavapai County. 3–8 yard dumpsters, flexible pickup schedules for homes and businesses."
        path="/front-load"
      />
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-14">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Front-Load Service" }]} />
          <div className="mt-8 grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <h1 className="font-heading font-extrabold tracking-tight text-4xl sm:text-5xl text-slate-900 leading-[1.05]">Front-Load Dumpster Service</h1>
              <p className="mt-4 text-lg text-slate-600 leading-relaxed">
                Reliable recurring waste service with branded 3–8 yard dumpsters. Weekly, multiple times per week, or a custom schedule based on your waste volume.
              </p>
            </div>
            <img src="/assets/yws/uploads/front-load-pair.jpeg" alt="Branded YWS front-load dumpsters placed at a local property" className="rounded-2xl w-full aspect-[16/10] object-cover shadow-xl" data-testid="frontload-hub-image" />
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 gap-6">
          <Reveal>
            <Link to="/front-load/residential" className="group block bg-white rounded-2xl border-2 border-sky-600 p-8 h-full shadow-lg shadow-sky-600/10 hover:shadow-2xl hover:-translate-y-1 transition-all" data-testid="frontload-hub-residential">
              <HomeIcon className="h-8 w-8 text-sky-600 mb-4" />
              <h2 className="font-heading font-bold text-2xl text-slate-900">Residential Front-Load</h2>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed">Reliable recurring waste service for your home or property, on a schedule that fits.</p>
              <span className="inline-flex items-center gap-1.5 mt-5 text-sm font-heading font-semibold text-sky-700 group-hover:gap-2.5 transition-all">
                Residential Service <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/front-load/commercial" className="group block bg-white rounded-2xl border border-slate-200 p-8 h-full hover:shadow-xl hover:-translate-y-1 transition-all" data-testid="frontload-hub-commercial">
              <Building2 className="h-8 w-8 text-sky-600 mb-4" />
              <h2 className="font-heading font-bold text-2xl text-slate-900">Commercial Front-Load</h2>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed">Flexible waste service for local businesses — sized and scheduled around your operation.</p>
              <span className="inline-flex items-center gap-1.5 mt-5 text-sm font-heading font-semibold text-sky-700 group-hover:gap-2.5 transition-all">
                Commercial Service <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          </Reveal>
        </div>
      </section>

      <CTASection title="Need a Roll-Off Instead?" subtitle="For projects and construction, our roll-off dumpsters run 20–40 yards with no maximum rental period." dark={false} />
    </>
  );
}
